module.exports = __webpack_public_path__ + "static/media/calendar.931bc989.svg";